import React, {useState,useRef}  from 'react'
import {localestr,isNumeric} from '../utils'
import icon from '../icons.svg'; 

function Calc({value,caption,text,setValue,add_value,add_data,setModal}){
    const [val, setVal] = useState(value||'0') 
    const [cnt, setCnt] = useState(0) 
    const [add, setAdd] = useState(parseInt(add_value)) 
    const targetRef = useRef()
   
    const newVal=(v)=>{
        let vl=val+''+v
        if(v===-1) vl=(''+val).substring(0,(''+val).length-1)||'0'
        else if(cnt===0) vl=v
        if(vl==='.') vl='0.'
        setVal(vl)
        setCnt(1)
    }

    const newKey=(e)=>{
        if(e.key==='Enter'){
            setValue(val||'-1')
            setModal('')
            return
        }
        if(e.key==='Backspace' && val.length){
            let vl=val.substring(0,val.length-1)
            setVal(vl||'0')
            setCnt(1)
        }
        if(!isNumeric(e.key)&&e.key!=='.') return
        let vl=val+''+e.key
        if(cnt===0) {
            vl=e.key
            setCnt(1)
        }
        setVal(vl)
    }

    const setValue_=()=>{
        if(add_data){
            if(!add) return
            setValue(''+parseFloat(val)+'-'+add)
            setModal('')
        } else {
            if(caption===localestr('Гостей')&&parseFloat(val)===0) return
            setValue(parseFloat(val))
            setModal('')
        }
    }

    const closeWnd=()=>{
        if(caption===localestr('Гостей')&&parseFloat(value||0)===0) return
        setModal('')
    }

    const setFocus=(el)=>{
        if (!el) return
        el.focus()
    }

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
        e = e || window.event;
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }
      
    function elementDrag(e) {
        const elmnt=document.getElementById('calc')
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
      
    function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
    }
      
    //const stl={border:'1px solid #00000022',background:'#FFFFFF44',margin:'2px'}
    const stl={margin:'4px',width:'48px'}
    const stl2={height:'48px',lineHeight:'48px'}

    let add_cont1=<div className='ord_button2 toolBarItem2' title={localestr('OK')} onClick={()=>{setValue_()}} style={{width:'84px',height:'39px',lineHeight:'32px',margin:'12px 4px 4px 28px'}}>
                {localestr('OK')}</div>
    let add_cont2=null
    if(add_data){
        const st={marginLeft:'10px',marginTop:'10px'}
        let items=(add_data.options||[]).map((option) => (
                <div key={option.value} style={st}><input type="radio" name={'add'} value={option.value} id={'add'+option.value} checked={add === option.value} 
                        onChange={()=>{setAdd(option.value)}}
                    /><label htmlFor={'add'+option.value}>{option.name}</label>
                </div>
            ))
        add_cont2=<><div style={{margin:'20px 0 0 0',display:'flex',flexDirection:'column',justifyContent:'center',fontSize:'larger',fontWeight:'bold'}}>
            <div>{add_data.name}</div>{items}
        </div>
        <div style={{margin:'20px 0 0 0',display:'flex',justifyContent:'center',fontSize:'larger',fontWeight:'bold'}}>
            <div className='ord_button2 toolBarItem2' title={localestr('OK')} onClick={()=>{setValue_()}} style={{width:'84px',height:'39px',lineHeight:'32px',margin:'4px'}}>
                {localestr('OK')}</div>
        </div>
        </>
        add_cont1=<div style={{width:'84px',height:'39px',lineHeight:'32px',margin:'12px 4px 4px 28px'}}></div>
    }

    let cont_text=null
    if(text){
        cont_text=text
    }

    return(
        <div className='modal'><div className='window'  id='calc'>
            <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{caption||null}</div><div className='closebtn' onClick={()=>{closeWnd()}}/></div>
            <div className='content'>
            <div style={{whiteSpace:'pre'}}>
                {cont_text}
            </div>
            <div tabIndex='0' style={{margin:'5px 0 0 0',fontSize:'larger',fontWeight:'bold',display:'flex',justifyContent:'right',padding: '5px',border:'solid 2px #00000022',borderRadius:'5px'}} ref={el=>{setFocus(el);return targetRef}} onKeyUp={(e)=>{newKey(e)}}>
                {parseFloat(val).toFixed(3)}
            </div>
            <div style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={stl} className='login_btn' title={localestr('7')} onClick={()=>{newVal('7')}}><div style={stl2}>7</div></div>
            <div style={stl} className='login_btn' title={localestr('8')} onClick={()=>{newVal('8')}}><div style={stl2}>8</div></div>
            <div style={stl} className='login_btn' title={localestr('9')} onClick={()=>{newVal('9')}}><div style={stl2}>9</div></div>
            <div style={{width:'8px'}}></div>
            <div style={{margin:'0px',background:'none',border:'none'}} className='login_btn' title={localestr('Стерти')} onClick={()=>{newVal(-1)}}><div><img style={{width:'24px',height:'24px'}} src={icon+'#key_b'} alt='' /></div></div>
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
            <div style={stl} className='login_btn' title={localestr('4')} onClick={()=>{newVal('4')}}><div style={stl2}>4</div></div>
            <div style={stl} className='login_btn' title={localestr('5')} onClick={()=>{newVal('5')}}><div style={stl2}>5</div></div>
            <div style={stl} className='login_btn' title={localestr('6')} onClick={()=>{newVal('6')}}><div style={stl2}>6</div></div>
            <div style={{width:'8px'}}></div>
            <div style={{margin:'0px',background:'none',border:'none'}} className='login_btn' title={localestr('Стерти')} onClick={()=>{setVal('0')}}><div><img style={{width:'18px',height:'18px'}} src={icon+'#calcx'} alt='' /></div></div>
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
            <div style={stl} className='login_btn' title={localestr('1')} onClick={()=>{newVal('1')}}><div style={stl2}>1</div></div>
            <div style={stl} className='login_btn' title={localestr('2')} onClick={()=>{newVal('2')}}><div style={stl2}>2</div></div>
            <div style={stl} className='login_btn' title={localestr('3')} onClick={()=>{newVal('3')}}><div style={stl2}>3</div></div>
            <div style={{width:'8px'}}></div>
            <div style={{margin:'0px',background:'none',border:'none'}} className='login_btn'></div>
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
            <div style={stl} className='login_btn' title={localestr('0')} onClick={()=>{newVal('0')}}><div style={stl2}>0</div></div>
            <div style={stl} className='login_btn' title={localestr('.')} onClick={()=>{newVal('.')}}><div style={stl2}>.</div></div>
            <div style={{width:'8px'}}></div>
            {add_cont1}
            </div>{add_cont2}</div>
        </div></div>
    )
}

export default Calc